import { OrderProductType } from 'src/types/order';
import { TableRowType } from 'src/types/table';

type OrderProductDisplaySource = Partial<OrderProductType> | TableRowType;

const pickFirstNonEmptyString = (...values: unknown[]): string => {
    for (const value of values) {
        if (typeof value === 'string' && value.trim()) {
            return value;
        }
    }
    return '';
};

const getProductObject = (orderProduct: OrderProductDisplaySource): TableRowType | undefined => {
    const product = orderProduct.PRODUCT;
    if (product && typeof product === 'object') {
        return product as TableRowType;
    }
    return undefined;
};

export const getOrderProductDisplayName = (orderProduct: OrderProductDisplaySource): string => {
    const product = getProductObject(orderProduct);
    return pickFirstNonEmptyString(orderProduct.PRODUCT_NAME, orderProduct.NAME, product?.NAME);
};

export const getOrderProductDisplaySku = (orderProduct: OrderProductDisplaySource): string => {
    const product = getProductObject(orderProduct);
    return pickFirstNonEmptyString(orderProduct.SKU, orderProduct.PRODUCT_SKU, product?.SKU);
};
